import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=46eac60e&scoped=true&"
import script from "./AlertForm.vue?vue&type=script&lang=ts&"
export * from "./AlertForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertForm.vue?vue&type=style&index=0&id=46eac60e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eac60e",
  null
  
)

export default component.exports